const DEFAULT_LEGAL_RETURN_TO = '/catalog';
export const LEGAL_SUPPORT_EMAIL = 'info@inhound.club';

function sanitizeReturnTo(returnTo?: string | null) {
  if (!returnTo || !returnTo.startsWith('/')) {
    return null;
  }

  return returnTo;
}

export function buildLegalHref(
  path: '/legal' | '/legal/offer' | '/legal/privacy' | '/legal/payment',
  returnTo?: string | null,
) {
  const safeReturnTo = sanitizeReturnTo(returnTo);
  if (!safeReturnTo) {
    return path;
  }

  return `${path}?returnTo=${encodeURIComponent(safeReturnTo)}`;
}

export function resolveLegalReturnTo(search: string, fallback = DEFAULT_LEGAL_RETURN_TO) {
  const params = new URLSearchParams(search);
  return sanitizeReturnTo(params.get('returnTo')) ?? fallback;
}

export function openSupportEmail(subject?: string) {
  const params = new URLSearchParams();
  if (subject) {
    params.set('subject', subject);
  }

  if (typeof window === 'undefined') return;
  const url = `mailto:${LEGAL_SUPPORT_EMAIL}${params.toString() ? `?${params.toString()}` : ''}`;
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) {
    window.location.assign(url);
  }
}
